import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import { FeatureFlags, SysState } from "reducers/sysReducer";

import {
  ADMIN_CASE_DOCUMENTS_LIST_FAILURE,
  ADMIN_CASE_DOCUMENTS_LIST_REQUEST,
  ADMIN_CASE_DOCUMENTS_LIST_SUCCESS,
  ADMIN_CASE_DOCUMENT_FAILURE,
  ADMIN_CASE_DOCUMENT_REQUEST,
  ADMIN_CASE_DOCUMENT_SUCCESS,
  ADMIN_DELETE_CASE_DOCUMENT_FAILURE,
  ADMIN_DELETE_CASE_DOCUMENT_REQUEST,
  ADMIN_DELETE_CASE_DOCUMENT_SUCCESS,
  ADMIN_OPEN_CASE_DOCUMENT,
  ADMIN_UPDATE_CASE_DOCUMENT_FAILURE,
  ADMIN_UPDATE_CASE_DOCUMENT_REQUEST,
  ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS,
  ADMIN_UPLOAD_CASE_DOCUMENT_FAILURE,
  ADMIN_UPLOAD_CASE_DOCUMENT_REQUEST,
  ADMIN_UPLOAD_CASE_DOCUMENT_SUCCESS,
} from "../actions/adminConstants";
import {
  CASE_OPEN_DOCUMENT_FAILURE,
  CASE_OPEN_DOCUMENT_MISSING,
  CASE_OPEN_DOCUMENT_SUCCESS,
} from "../actions/constants";
import { addToast, nextId } from "../actions/toastActions";

function* fetchAdminDocument(action: any): any {
  try {
    const result = yield call(ApiService.retrieveAdminCaseDocument, {
      id: action.payload,
    });
    yield put({
      type: ADMIN_CASE_DOCUMENT_SUCCESS,
      payload: result,
    });
  } catch (e: any) {
    yield put({
      type: ADMIN_CASE_DOCUMENT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* fetchAdminDocuments(action: any): any {
  try {
    const results = yield call(
      ApiService.listAdminCaseDocuments,
      action.payload.filters
    );
    yield put({
      type: ADMIN_CASE_DOCUMENTS_LIST_SUCCESS,
      payload: results,
    });
  } catch (e: any) {
    yield put({
      type: ADMIN_CASE_DOCUMENTS_LIST_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* openAdminDocument(action: any): any {
  try {
    const result = yield call(ApiService.retrieveAdminCaseDocument, {
      id: action.payload,
    });
    if (!result.presigned_url) {
      yield all([
        put(
          addToast(
            {
              kind: "danger",
              title: "Document Missing",
              message:
                "If this problem persists, please contact support@pathologywatch.com",
            },
            nextId()
          )
        ),
        put({ type: CASE_OPEN_DOCUMENT_MISSING, payload: action.payload.id }),
      ]);
    } else {
      const features: FeatureFlags = yield select(
        ({ sys }: { sys: SysState }) => sys?.features
      );
      if (features?.documentViewWindow) {
        const width = Math.round(window.screen.availWidth / 2);
        const height = Math.round(window.screen.availHeight);
        const left = Math.round(window.screen.availWidth / 2);
        const top = 0;
        window.open(
          result.presigned_url,
          "_blank",
          `popup=yes,width=${width},height=${height},left=${left},top=${top}`
        );
      } else {
        window.open(result.presigned_url, "_blank");
      }
      yield put({ type: CASE_OPEN_DOCUMENT_SUCCESS, payload: result });
    }
  } catch (e) {
    yield put({
      type: CASE_OPEN_DOCUMENT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* updateAdminDocument(action: any): any {
  try {
    const response = yield call(ApiService.uploadDocumentAdminCaseDocument, {
      id: action.payload.document.get("id"),
      requestBody: action.payload.document,
    });
    yield put({
      type: ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS,
      payload: {
        ...response,
        case__accession: action.payload.document.case__accession,
      },
    });
    action.payload.closePanelFn && action.payload.closePanelFn();
  } catch (e: any) {
    yield put({
      type: ADMIN_UPDATE_CASE_DOCUMENT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* uploadAdminDocument(action: any): any {
  try {
    const response = yield call(ApiService.uploadAdminCaseDocument, {
      requestBody: action.payload.document,
    });
    yield put({
      type: ADMIN_UPLOAD_CASE_DOCUMENT_SUCCESS,
      payload: {
        ...response,
        case__accession: action.payload.adminCase?.accession,
      },
    });
    action.payload.closePanelFn && action.payload.closePanelFn();
  } catch (e: any) {
    yield put({
      type: ADMIN_UPLOAD_CASE_DOCUMENT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* deleteAdminDocument(action: any): any {
  try {
    yield call(ApiService.destroyAdminCaseDocument, {
      id: action.payload.id,
    });
    yield put({
      type: ADMIN_DELETE_CASE_DOCUMENT_SUCCESS,
      payload: {
        id: action.payload.id,
      },
    });
    action.payload.closePanelFn && action.payload.closePanelFn();
  } catch (e: any) {
    yield put({
      type: ADMIN_DELETE_CASE_DOCUMENT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* caseDocumentsSaga() {
  yield takeLatest(ADMIN_CASE_DOCUMENTS_LIST_REQUEST, fetchAdminDocuments);
  yield takeLatest(ADMIN_CASE_DOCUMENT_REQUEST, fetchAdminDocument);
  yield takeLatest(ADMIN_OPEN_CASE_DOCUMENT, openAdminDocument);
  yield takeLatest(ADMIN_UPDATE_CASE_DOCUMENT_REQUEST, updateAdminDocument);
  yield takeLatest(ADMIN_UPLOAD_CASE_DOCUMENT_REQUEST, uploadAdminDocument);
  yield takeLatest(ADMIN_DELETE_CASE_DOCUMENT_REQUEST, deleteAdminDocument);
}
